import { useIO, useLinked, useModel } from "@type-r/react";
import { Loading } from "lqx-react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { Company } from "../../api/company";
import { DocumentSource } from "../../api/documentSource";
import { IngestionJob } from "../../api/ingestionJob";
import { ImportTemplatesLookup } from "../../api/lookups";
import { ManualUnappliedCash } from "../../api/unappliedCash";
import { AddAssetsStep } from "../add-assets-step";
import { UnappliedCashForm } from "./unapplied-cash-form";

export const AddUnappliedCashesStep = ({ next, back, cancel, job }:
  { next?, back?, cancel?, job: IngestionJob }) => {
  const assetExtensions = "*.xlsx,*.xls,*.csv";

  const userTemplates = useModel(ImportTemplatesLookup);
  const $allowedExtension = useLinked(assetExtensions);
  const $userTemplate = useLinked<{ id?: string }>(null)
    .onChange(x => applyImportTemplateExtension(x.id));
  const $dataHolderId = useLinked<Company>(new Company());

  //TODO we removed organizationId bacause organizationId from INBLOCK
  //const $organizationId = useLinked(localUserInfo.organization_id);

  const isReady = useIO(async () => {
    const params = { params: { assetTypeId: AssetType.unappliedCash } }
    await userTemplates.fetch(params).catch(e => console.error(e));
  }, []);

  const applyImportTemplateExtension = (userTemplateId) => {
    let importTemplateExtension: string;
    if (Boolean(userTemplateId) && Boolean(userTemplates)) {
      const userTemplate = userTemplates.items.find((item) => item.id === userTemplateId);
      if (userTemplate) {
        importTemplateExtension = userTemplate.originalFileName.split(".").pop();
        $allowedExtension.set(`*.${importTemplateExtension}`);
      }
    } else {
      $allowedExtension.set(assetExtensions);
    }
  }
  const showDownloadTemplate = true;

  return isReady ?
    <>
      <AddAssetsStep
        assetName="Unapplied Cash"
        allowedExtension={$allowedExtension.value}
        jobInfoProvider={() => ({ ...DocumentSource.UnappliedCash, userTemplateId: $userTemplate.value.id, dataHolderId: Boolean($dataHolderId.value) ? $dataHolderId.value.id : null })}
        $dataHolderId={$dataHolderId}
        userTemplates={userTemplates}
        $userTemplate={$userTemplate}
        showDownloadTemplate={showDownloadTemplate}
        assetForm={manualUnappliedCash => <UnappliedCashForm unappliedCash={manualUnappliedCash}></UnappliedCashForm>}
        manualAssetModel={ManualUnappliedCash}
        next={next} back={back} cancel={cancel} job={job} />
    </> : <Loading />
};